import { render, staticRenderFns } from "./Excel.vue?vue&type=template&id=8455f2b2&scoped=true&"
import script from "./Excel.vue?vue&type=script&lang=js&"
export * from "./Excel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8455f2b2",
  null
  
)

export default component.exports